import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { AnimatedFiltersWrapper } from "components/AnimatedHeaderOnScrollWrapper/AnimatedFiltersWrapper";
import { SetContainerRef } from "components/AnimatedHeaderOnScrollWrapper/types";
import { EdmMedicalPerson } from "lib/graphql/megaSchema";
import {
  staffSettingsSearchFilterAtom,
  staffSettingsStaffGenreFilterAtom,
} from "views/StaffSchedule/StaffSettings/atoms";
import { DataFetchErrorIcon } from "views/StaffSchedule/StaffSettings/components/DataFetchErrorIcon";
import { StaffFilters } from "views/StaffSchedule/StaffSettings/components/StaffFilters";
import { StaffList } from "views/StaffSchedule/StaffSettings/components/StaffList";
import { StaffSettingsPanel } from "views/StaffSchedule/StaffSettings/components/StaffSettingsPanel";
import { useStaffSettings } from "views/StaffSchedule/StaffSettings/hooks/useStaffSettings";

type Props = {
  isScrolled: boolean;
  setContainerRef: SetContainerRef;
};

export const StaffSettings = ({ isScrolled, setContainerRef }: Props) => {
  const [selectedStaffGenre, setSelectedStaffGenre] = useAtom(
    staffSettingsStaffGenreFilterAtom,
  );
  const [searchInputValue, setSelectedSearchInputValue] = useAtom(
    staffSettingsSearchFilterAtom,
  );

  const { filteredStaff, loading } = useStaffSettings({
    selectedStaffGenre,
    searchInputValue,
  });

  const [selectedStaff, setSelectedStaff] = useState<EdmMedicalPerson | null>(
    filteredStaff ? filteredStaff[0] : null,
  );

  useEffect(() => {
    setSelectedStaff(filteredStaff ? filteredStaff[0] : null);
  }, [loading, searchInputValue, selectedStaffGenre]);

  return (
    <div className="flex h-full flex-col gap-2">
      <AnimatedFiltersWrapper isScrolled={isScrolled}>
        <StaffFilters
          selectedStaffGenre={selectedStaffGenre}
          searchInputValue={searchInputValue}
          setSelectedStaffGenre={setSelectedStaffGenre}
          setSearchInputValue={setSelectedSearchInputValue}
        />
      </AnimatedFiltersWrapper>

      {loading ? (
        <div className="bg-jutro-new-warm-gray-50 w-full flex-1 animate-pulse rounded-2xl duration-300" />
      ) : !filteredStaff ? (
        <div className="bg-jutro-new-warm-gray-50/50 flex h-full flex-col items-center justify-center gap-8 rounded-2xl">
          <DataFetchErrorIcon />
          <div className="font-paragraph-0 flex flex-col text-center">
            <span>Nie udało się pobrać listy.</span>
            <span>Odśwież stronę, żeby spróbować ponownie</span>
          </div>
        </div>
      ) : (
        <div className="flex min-h-0 gap-2">
          <StaffList
            filteredStaff={filteredStaff}
            selectedStaff={selectedStaff}
            setSelectedStaff={setSelectedStaff}
            setContainerRef={setContainerRef}
          />

          <StaffSettingsPanel selectedStaff={selectedStaff} />
        </div>
      )}
    </div>
  );
};
